module.exports = __webpack_public_path__ + "img/acf5216fec5babdbdd528e2440804997.png";